import { FC, useState } from 'react'
import { Repeat } from 'lucide-react'
import { AlertDialog } from '@/components/ds2'
import { cn } from 'utils/cn'

interface ResendEmailButtonProps {
    /** Who the copy goes to — named in the confirm so the operator knows which broker gets it. */
    contactEmail: string
    disabled: boolean
    compact?: boolean
    onConfirm: () => void
}

/**
 * "Send again" on one of our own chat bubbles. Re-sending reaches a broker's inbox, so a click only opens
 * a confirm; the send itself happens on Confirm.
 */
export const ResendEmailButton: FC<ResendEmailButtonProps> = ({ contactEmail, disabled, compact, onConfirm }) => {
    const [confirmOpen, setConfirmOpen] = useState(false)

    return (
        <>
            <button
                type="button"
                onClick={() => setConfirmOpen(true)}
                disabled={disabled}
                title="Send this email again"
                aria-label="Send this email again"
                className="flex items-center justify-center rounded p-0.5 bg-transparent border-none cursor-pointer text-[#8C9095] hover:text-[var(--lh-fg)] hover:bg-[var(--lh-surface-secondary)] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
                <Repeat className={cn(compact ? 'w-3 h-3' : 'w-3.5 h-3.5')} />
            </button>
            <AlertDialog
                open={confirmOpen}
                onClose={() => setConfirmOpen(false)}
                title="Send this email again?"
                description={`The same email goes to ${contactEmail} as a reply in this thread.`}
                confirmLabel="Send again"
                variant="accent"
                onConfirm={onConfirm}
            />
        </>
    )
}
